<template lang="html">
<div>
    <div class="card mb-2" style="width:100%;">
        <div class="card-body d-flex flex-row h-100 align-items-center justify-content-between">
            <div class="d-flex flex-column justify-content-center">
                <div class="mb-1 human-date">{{msg.started_at|human_date}}</div>
                <div style="width:200px;overflow:hidden;">
                    <a class="text-muted"
                       target="blank"
                       style=""
                       :href="get_url(msg.filename)">
                        {{msg.filename}}
                    </a>
                </div>
            </div>

            <div class="d-flex flex-row ms-3">
                <div class="d-flex flex-column align-items-center">
                    <div class="text-muted text-small text-uppercase">Erreurs</div>
                    <div class="text-danger">{{msg.errors_count_clean}}</div>
                </div>
                <div class="d-flex flex-column align-items-center ms-3">
                    <div class="text-muted text-small text-uppercase">Warning</div>
                    <div class="text-alternate">{{msg.nb_warning}}</div>
                </div>
                <div class="d-flex flex-column align-items-center ms-3">
                    <div class="text-muted text-small text-uppercase">Ajouté</div>
                    <div class="text-alternate">{{msg.created_count}}</div>
                </div>
                <div class="d-flex flex-column align-items-center ms-3">
                    <div class="text-muted text-small text-uppercase">Modifié</div>
                    <div class="text-success">{{msg.modified_count}}</div>
                </div>
                <div class="d-flex flex-column align-items-center ms-3" @click="openBox()">
                    <a href="#" class="btn btn-icon btn-icon-only btn-outline-primary more-btn me-2" data-bs-toggle="collapse"
                        :data-bs-target="'#collapseLine1'+msg.uid"
                        aria-expanded="true"
                        aria-controls="collapseMore">
                        <i class="icon-12 bi-three-dots-vertical"></i>
                    </a>
                </div>
            </div>
        </div>
        <div v-show="opened" class="collapse card-footer" :id="'collapseLine1'+msg.uid" style="min-height: 54px;">
            <div v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>&nbsp; Chargement</span>
            </div>
            <table v-else data-v-dbbcf580="" class="table">
                <tr data-v-dbbcf580="">
                    <th data-v-dbbcf580=""></th>
                    <th data-v-dbbcf580="">errors</th>
                    <th data-v-dbbcf580="">warning</th>
                    <th data-v-dbbcf580="">too old</th>
                    <th data-v-dbbcf580="">created</th>
                    <th data-v-dbbcf580="">modified</th>
                    <th data-v-dbbcf580="">last review</th>
                </tr>
                <tr v-for="plat in details" data-v-dbbcf580="">
                    <td data-v-dbbcf580="">{{plat.platform}}</td>
                    <td data-v-dbbcf580="">
                        <a data-v-dbbcf580="" :href="get_admin_url('ERROR', plat.platform)" target="blank">{{plat.info.ERROR}}</a>
                    </td>
                    <td data-v-dbbcf580="">
                        <a data-v-dbbcf580="" :href="get_admin_url('WARNING', plat.platform)" target="blank">{{plat.info.WARNING}}</a>
                    </td>
                    <td data-v-dbbcf580="">
                        <a data-v-dbbcf580="" :href="get_admin_url('too_old', plat.platform)" target="blank">{{plat.info.too_old}}</a>
                    </td>
                    <td data-v-dbbcf580="">
                        <a data-v-dbbcf580="" :href="get_admin_url('created', plat.platform)" target="blank">{{plat.info.created}}</a>
                    </td>
                    <td data-v-dbbcf580="">
                        <a data-v-dbbcf580="" :href="get_admin_url('modified', plat.platform)" target="blank">{{plat.info.modified}}</a>
                    </td>
                    <td data-v-dbbcf580="">
                        <span data-v-dbbcf580="" :class="{'has-text-danger': isOlderThanDays(3, plat.last_review)}">{{plat.last_review|human_date}}</span>
                    </td>
                </tr>
                <tr data-v-dbbcf580="">
                    <td data-v-dbbcf580="" style="font-weight: bold;">Total</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details('ERROR', details)}}</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details('WARNING', details)}}</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details('too_old', details)}}</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details('created', details)}}</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details('modified', details)}}</td>
                    <td data-v-dbbcf580="" style="padding-left: 17px; font-weight: bold;">{{sum_details(null, details)}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>
</template>


<script>
import settings from '@/settings.coffee';
import IMPORTREPORTLINE_SET from '@/gql/queries/importreportlineSet.graphql';
import LAST_REVIEW_BY_PLATFORM from '@/gql/queries/lastReviewByPlatform.graphql';
import { gqlQuery } from '@/gqlClient.js';
import moment from "moment";

export default {
  name: "ImportReport",
  props: {
    msg: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      opened: false,
      loading: false,
      details: []
    };
  },
  computed: {},
  methods: {
    sum_details(mkey, details) {
      let res = 0;
      for (let plt of details) {
        if (mkey) {
          res += plt.info[mkey];
        } else {
          res += plt.info["ERROR"] + plt.info["WARNING"] + plt.info["too_old"] + plt.info["created"] + plt.info["modified"];
        }
      }
      return res;
    },
    get_admin_url(filter, platform) {
      let url = settings.backendUrl + "/admin/review/importreportline/?o=1&import_report=" + this.msg.uid;
      if (platform !== undefined && platform !== null && platform !== "null") {
        url += "&platform=" + platform;
      }
      if (filter === "ERROR") url += "&level__exact=error";
      if (filter === "WARNING") url += "&level__exact=warning";
      if (filter === "too_old") url += "&title=review+too+old";
      if (filter === "created") url += "&title=review+created";
      if (filter === "modified") url += "&title=review+modified";
      return url;
    },
    get_url(filename) {
      return settings.backendMediaUrl + filename.replaceAll(":", '');
    },
    isOlderThanDays(days, isoDate) {
      const d = moment(isoDate);
      const now = moment();
      return now.diff(d, 'days') > days;
    },
    async openBox() {
      this.opened = !this.opened;
      if (!this.opened) return;
      this.loading = true;
      const data = await gqlQuery(IMPORTREPORTLINE_SET, { report_uid: this.msg.uid });
      const by_platform = {};
      const lines = data.body.data.importreportline_set;
      for (let l of lines) {
        if (!(l.platform in Object.keys(by_platform))) {
          by_platform[l.platform] = {
            'ERROR': 0,
            'WARNING': 0,
            'created': 0,
            'modified': 0,
            'exists': 0,
            'too_old': 0
          };
        }
        if (l.level === "ERROR") {
          by_platform[l.platform]['ERROR'] += 1;
        } else if (l.level === "WARNING") {
          by_platform[l.platform]['WARNING'] += 1;
        } else if (l.level === "INFO" && l.title === "review created") {
          by_platform[l.platform]['created'] += 1;
        } else if (l.level === "INFO" && l.title === "review modified") {
          by_platform[l.platform]['modified'] += 1;
        } else if (l.level === "INFO" && l.title === "review too old") {
          by_platform[l.platform]['too_old'] += 1;
        }
      }
      const data2 = await gqlQuery(LAST_REVIEW_BY_PLATFORM, {});
      const details = [];
      for (let plat of Object.keys(by_platform).sort()) {
        let last_review = null;
        for (let r of data2.body.data.last_review_by_platform) {
          if (r && r.platform.slug === plat) {
            last_review = r.created_on;
          }
        }
        details.push({
          platform: plat,
          info: by_platform[plat],
          last_review: last_review
        });
      }
      this.details = details;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.human-date::first-letter {
    text-transform: uppercase;
}
</style>
